import { Component, NgZone } from '@angular/core';
import { Store } from '@ngxs/store';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { delay } from 'rxjs/operators';
import { ApplicationSelectors } from '../../../shared/store/application/application.selectors';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [NgxSpinnerModule, TranslatePipe],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  constructor(
    private readonly store: Store,
    private readonly ngZone: NgZone,
    private readonly spinner: NgxSpinnerService
  ) {
    store
      .select(ApplicationSelectors.loader)
      .pipe(delay(0))
      .subscribe((map: Map<string, boolean>) => {
        this.ngZone.run(() => {
          if (map.size > 0) {
            this.spinner.show('main');
          } else {
            this.spinner.hide('main');
          }
        });
      });
  }
}
